import React from 'react';
import PropTypes from 'prop-types';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../shared/components/VerbButton';
import VerbHeading from '../../../../shared/components/VerbHeading';
import Image from '../../../../shared/components/Image';
import MyPathwayMilestones from './MyPathwayMilestones';
import MyPathwaySelect from './MyPathwaySelect';

const MyPathwayMobileView = ({
    isTeamPage,
    pathwayToDisplay,
    handlePathwaySelect,
    pathwayOptionsForSelect,
    selectOptions,
    setSelectOptions,
    setToDefaultPathway,
    handleShowCompletedPathways,
    upNext,
    history,
    buttonText,
    showPathway,
    userPathwayDateEdited,
    loggedInUserCompany,
    isVerbAdmin,
    updateUserPathway,
    toggleCalendarModal,
    collectionsById,
    userCollectionsById,
    getEventHref,
    onClickBack,
    toggleShowPathway,
    CTAClickHandler,
    updateUserPathwayContentItem,
    setModalLoadingOverlay,
    markTaskAsCompleted
}) => (
    <div className={'mobile-my-pathway-container'}>
        <div className={'sub-my-pathway-container'}>
            {!isTeamPage ? (
                <>
                    <VerbHeading defaultMessage={'Pathways in Progress'} className={'my-pathway-title'} hNumber={3} />
                    <div className={'pathway-select-mobile'}>
                        <MyPathwaySelect
                            setSelectOptions={setSelectOptions}
                            setToDefaultPathway={setToDefaultPathway}
                            handleShowCompletedPathways={handleShowCompletedPathways}
                            handlePathwaySelect={handlePathwaySelect}
                            pathwayOptionsForSelect={pathwayOptionsForSelect}
                            selectOptions={selectOptions}
                            pathwayToDisplay={pathwayToDisplay}
                        />
                    </div>
                </>
            ) : null}
            {upNext?.isCompleted && !isTeamPage ? (
                <>
                    <div className={'next-asset-image-container'}>
                        <Image
                            className={'next-asset-image'}
                            src={
                                'https://res.cloudinary.com/verb-prod/image/upload/v1594671134/Pathways_ActivityInterstitialHerbie1_sqmosa.png'
                            }
                            dimension={{ h: 450, w: 450 }}
                        />
                    </div>
                    <div className={'mobile-my-pathway-up-next'}>
                        <div className={'asset-details'}>
                            <h3 className={'asset-title'}>Pathway Completed</h3>
                            {upNext.userPathwayId && (
                                <div className={'card-link'}>
                                    <VerbButton
                                        textId={'BUTTON_REVIEW'}
                                        defaultMessage={'REVIEW'}
                                        className={'mx-auto'}
                                        onClick={() => history.push(`/mypathway/${upNext.userPathwayId}/done`)}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className={'next-asset-image-container'}>
                        <Image
                            className={'next-asset-image'}
                            src={upNext.thumbnailImageUrl}
                            dimension={{ h: 450, w: 450 }}
                        />
                    </div>
                    <div className={'mobile-my-pathway-up-next'}>
                        <div className={'asset-details'}>
                            <h3 className={'asset-title'}>{upNext.name}</h3>
                            <div className={'card-link'}>
                                <VerbButton
                                    textId={'BUTTON_KEEP_LEARNING'}
                                    defaultMessage={buttonText}
                                    onClick={
                                        upNext.type === 'TASK' || upNext.parentType === 'TASK'
                                            ? () => markTaskAsCompleted(upNext.index, upNext)
                                            : CTAClickHandler
                                    }
                                    className={'mx-auto'}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )}
            <VerbButton
                buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                trailingFontAwesomeIcon={`fa-angle-down ${showPathway ? 'fa-flip-vertical' : ''}`}
                onClick={() => toggleShowPathway()}
                className={'mobile-show-pathway'}
            >
                SHOW PATHWAY
            </VerbButton>
            <div
                className={'my-pathway-milestones'}
                style={{ 'margin-top': userPathwayDateEdited ? '17px' : '30px' }}
                hidden={!showPathway}
            >
                <MyPathwayMilestones
                    pathwayToDisplay={pathwayToDisplay}
                    loggedInUserCompany={loggedInUserCompany}
                    isVerbAdmin={isVerbAdmin}
                    updateUserPathway={updateUserPathway}
                    toggleCalendarModal={toggleCalendarModal}
                    collectionsById={collectionsById}
                    userCollectionsById={userCollectionsById}
                    upNext={upNext}
                    getEventHref={getEventHref}
                    updateUserPathwayContentItem={updateUserPathwayContentItem}
                    setModalLoadingOverlay={setModalLoadingOverlay}
                    markTaskAsCompleted={markTaskAsCompleted}
                />
            </div>
            {!isTeamPage ? (
                <>
                    <span className={'change-pathway-text'}>
                        Would you like to start another pathway?
                        <div
                            className={'choose-new-pathway-text'}
                            onClick={() => {
                                window.scrollTo(0, 0);
                                onClickBack('browse');
                            }}
                        >
                            Add a new pathway.
                        </div>
                    </span>
                </>
            ) : null}
        </div>
    </div>
);

MyPathwayMobileView.propTypes = {
    isTeamPage: PropTypes.bool,
    pathwayToDisplay: PropTypes.object,
    handlePathwaySelect: PropTypes.func,
    pathwayOptionsForSelect: PropTypes.array,
    selectOptions: PropTypes.object,
    setSelectOptions: PropTypes.func,
    setToDefaultPathway: PropTypes.func,
    handleShowCompletedPathways: PropTypes.func,
    upNext: PropTypes.object,
    history: PropTypes.object,
    buttonText: PropTypes.string,
    showPathway: PropTypes.func,
    userPathwayDateEdited: PropTypes.bool,
    loggedInUserCompany: PropTypes.object,
    isVerbAdmin: PropTypes.bool,
    updateUserPathway: PropTypes.func,
    toggleCalendarModal: PropTypes.func,
    collectionsById: PropTypes.object,
    userCollectionsById: PropTypes.object,
    getEventHref: PropTypes.func,
    onClickBack: PropTypes.func,
    toggleShowPathway: PropTypes.func,
    CTAClickHandler: PropTypes.func,
    updateUserPathwayContentItem: PropTypes.func,
    setModalLoadingOverlay: PropTypes.func,
    markTaskAsCompleted: PropTypes.func
};

export default MyPathwayMobileView;
